module.exports = __webpack_public_path__ + "img/ID card_Sm.7ce3ab36.svg";